type RedirectionData = unknown

type UseRedirectionResult = {
  set: (redirection: RedirectionData) => void
  get: () => RedirectionData
  clear: () => void
}

let _redirection: RedirectionData
export function useRedirection (): UseRedirectionResult {
  const set = (redirection: RedirectionData): void => {
    _redirection = redirection
  }

  const get = (): RedirectionData => {
    return _redirection
  }

  const clear = (): void => {
    _redirection = undefined
  }

  return {
    set,
    get,
    clear,
  }
}
